import React from "react";
import SchemaTherapyImage from "../../../assets/schemaTherapy.png";
import {
  Diagram3,
  ClockHistory,
  CalendarCheck,
  People,
  Lightbulb,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "brain") return <Diagram3 className="therapy-icon" />;
  if (name === "history") return <ClockHistory className="therapy-icon" />;
  if (name === "today") return <CalendarCheck className="therapy-icon" />;
  if (name === "sessions") return <People className="therapy-icon" />;
  if (name === "idea") return <Lightbulb className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function SchemaTherapyModal({ setShow }) {
  return (
    <>
      <div className="therapy-modal-backdrop" onClick={() => setShow(false)} />

      <div
        className="modal fade show d-block therapy-modal-wrap"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={SchemaTherapyImage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="Schema Therapy"
                />

                <h5 className="therapy-modal-title">What is Schema Therapy</h5>

                <div className="therapy-modal-subtitle">
                  A depth based approach for long standing patterns
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="brain" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Schema Therapy
                    </div>
                    <div className="therapy-modal-item-text">
                      Schema therapy explores long standing themes that can develop from early experiences and shape how you
                      relate to yourself and others. It helps you understand these patterns and build healthier alternatives.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="history" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Where It Comes From
                    </div>
                    <div className="therapy-modal-item-text">
                      Schema therapy was developed by Jeffrey Young and integrates ideas from cognitive therapy, attachment,
                      psychodynamic approaches, and experiential techniques to support deeper, longer term change.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="today" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      What It Helps With
                    </div>
                    <div className="therapy-modal-item-text">
                      It can be helpful when certain patterns keep repeating, such as difficulties with self worth,
                      relationships, boundaries, or coping responses that feel hard to shift.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="sessions" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Modes and Practical Work
                    </div>
                    <div className="therapy-modal-item-text">
                      You work with different parts of the self, such as a vulnerable part, a coping part, or a critical part,
                      and practise new responses that support emotional needs and healthier choices.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      The core aim
                    </span>{" "}
                    is to understand your patterns with warmth and clarity, then build new ways of responding that feel more stable and supportive.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      Schema therapy supports people to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Spot repeated patterns and triggers earlier
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Understand emotional needs underneath coping habits
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Reduce self criticism and strengthen self compassion
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Build healthier responses in relationships and daily life
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      Young et al.
                    </div>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
